module.exports = __webpack_public_path__ + "img/ibms.67e1e59d.png";